import { useContext } from "react";
import { DropdownMenuContext } from "src/components/DropdownMenu/DropdownMenu.tsx";

export const useDropdownMenuContext = () => {
  const context = useContext(DropdownMenuContext);
  if (!context) {
    throw new Error(
      "useDropdownMenuContext must be used within a DropdownMenuContext",
    );
  }
  return context;
};
